/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React, { Component, PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './singleRealisation.css';
import Helmet from 'react-helmet';
import fetch from '../../core/fetch';
import $ from 'jquery';
import window from 'window-or-global';
import { Link } from 'react-router';

@withStyles(s)
export default class singleRealisation extends Component{
    
    constructor(props) {
        super(props);

        this.state = {
            realisations: [],
            realisation: [],
            slug: this.props.location.pathname.split("/").slice(-1).pop(),
            loader: true,
        };

        this.FindRealisation = this.FindRealisation.bind(this);
        this.BarPercent = this.BarPercent.bind(this);
        
    }

    componentDidMount() {

        this.GetRealisation();
        window.addEventListener('scroll', this.BarPercent);

    }

    componentWillUnmount(){
        
        window.removeEventListener('scroll', this.BarPercent);
    }

    FindRealisation(item){

        return item.slug === this.state.slug;

    }

    BarPercent() {

        // var elPos = $('.wrapCircles').offset();
        // var topPos = elPos.top;

        // var y = window.scrollY;
        // var wHeight = window.innerHeight;
        // var appear = topPos - wHeight+130;
        

        // if(y > appear){

        //     var val1 = 100;
        //     var $circle1 = $('#svg1 #bar1');

        //     if (isNaN(val1)) {
        //         val1 = 100; 
        //     }
        //     else{
        //         var r = $circle1.attr('r');
        //         var c = Math.PI*(r*2);

        //         if (val1 < 0) { 
        //             val1 = 0;
        //         }
        //         if (val1 > 100) { 
        //             val1 = 100;
        //         }

        //         var pct = ((100-val1)/100)*c;

        //         $circle1.css({ strokeDashoffset: pct});

        //     }

        //     var val2 = 100;
        //     var $circle2 = $('#svg2 #bar2');

        //     if (isNaN(val2)) {
        //         val1 = 100; 
        //     }
        //     else{
        //         var r = $circle2.attr('r');
        //         var c = Math.PI*(r*2);

        //         if (val2 < 0) { 
        //             val2 = 0;
        //         }
        //         if (val2 > 100) { 
        //             val2 = 100;
        //         }

        //         var pct = ((100-val2)/100)*c;

        //         $circle2.css({ strokeDashoffset: pct});

        //     }

        //     var val3 = 100;
        //     var $circle3 = $('#svg3 #bar3');

        //     if (isNaN(val3)) {
        //         val1 = 100; 
        //     }
        //     else{
        //         var r = $circle3.attr('r');
        //         var c = Math.PI*(r*2);

        //         if (val3 < 0) { 
        //             val3 = 0;
        //         }
        //         if (val3 > 100) { 
        //             val3 = 100;
        //         }

        //         var pct = ((100-val3)/100)*c;

        //         $circle3.css({ strokeDashoffset: pct});

        //     }

        // }
    }

    async GetRealisation() {
        const resp = await fetch('/graphql', {
            method: 'post',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                query: '{realisations{id, slug, title, content, excerpt, thumb1, thumb2, thumb3, logo, banniere, objectif, statistique, lienSite, libelleBtnSite}}',
            }),
            credentials: 'include',
        });
        const { data } = await resp.json();
        if (!data || !data.realisations) throw new Error('Erreur sur le chargement des réalisations !');

        if(data){
            this.setState({ loader: false })
        }

        this.setState({ realisations: data.realisations });

        this.setState({ realisation: this.state.realisations.find(this.FindRealisation) });

    }

    render(){
        const appear = this.state.loader ? 'appear' : '';
        var background = {
            backgroundColor: '#00bf43'
        }

        const title = this.state.realisation.title;
        const banniere = this.state.realisation.banniere;
        const logo = this.state.realisation.logo;
        const topContent = <div dangerouslySetInnerHTML={{ __html: this.state.realisation.content }} />;
        const middleContent = <div dangerouslySetInnerHTML={{ __html: this.state.realisation.objectif }} />;
        const bottomContent = <div dangerouslySetInnerHTML={{ __html: this.state.realisation.statistique }} />;
        const lien = this.state.realisation.lienSite;
        const libelle = this.state.realisation.libelleBtnSite;

        var backgroundImage = {
            backgroundImage: `url(${banniere})`,
        }
        
        return (
            <div className={s.root}>
                <Helmet title={title} />
                <div className={`spinner ${appear}`} style={background} ></div>
                <div id="realisation" className={`realisation`}>
                    <div className={`bgRealisation`}>
                        <div className={`bgDark`}>
                            <img src={logo} alt="Logo de la réalisation" />
                        </div>
                        <div className={`banniere`} style={backgroundImage} alt="bannière de la réalisation" />
                    </div>
                    {topContent}
                    {middleContent}
                    {bottomContent}
                    <div className={`container`}>
                        <div className={`lienSite`}>
                            <div className={`btnSite`}>
                                <Link to={lien} target="_blank">{libelle}</Link>
                            </div>
                        </div>
                        <div className={`bottomSection`}>
                            <div className={`w50`}>
                                <span className={`back`}><Link to="/realisations">Retour aux réalisations</Link></span>
                            </div>
                            <div className={`w50`}>
                                <span className={`titleBottomSection`}>Devenez notre prochaine réalisation</span>
                                <span className={`sousTitreBottomSection`}>Contactez-nous dès maintenant pour nous faire part de votre projet.</span>
                                <span className={`lienContact`}><Link to="/contact">Écrivez-nous maintenant</Link></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./containers/singleRealisation/singleRealisation.js